export default function ImageLoader({ src }: { src: string }) {
  //return `http://localhost:3000/${src}`;
  return src
}